import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { ref, computed } from 'vue';

import { createStyle } from '@v1/composables/create-style';
import { StyleExtender } from '@v1/composables/style-extender';
import { useTruncateStyle } from '@v1/composables/use-styles';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseText',
  props: {
  disableTruncate: {
    type: Boolean,
    required: false,
    default: true,
  },
  inline: {
    type: Boolean,
    required: false,
    default: false,
  },
  inlineBlock: {
    type: Boolean,
    required: false,
    default: false,
  },
  nowrap: {
    type: Boolean,
    required: false,
    default: false,
  },
  span: {
    type: Boolean,
    required: false,
    default: false,
  },
  usePreline: {
    type: Boolean,
    required: false,
    default: false,
  },
  styleExtension: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  asReactive: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const styleExtender = new StyleExtender({ variablePrefix: '--v1-base-text' });

const props = __props;

const truncateStyle = ref(useTruncateStyle());

const truncate = computed(() => (
  !props.disableTruncate
  && !props.inline
  && !props.inlineBlock));

const style = createStyle({
  container: {
    ...(props.usePreline ? {
      whiteSpace: 'pre-line',
    } : {}),
    ...(props.nowrap ? {
      textWrap: 'nowrap',
    } : {}),
  },
}, {
  asReactive: props.asReactive,
});

styleExtender.extend({
  target: style.container,
  extension: props.styleExtension.container,
  selector: 'container',
});

if (props.inline || props.inlineBlock) {
  style.container.display = props.inline ? 'inline' : 'inline-block';
  style.container.verticalAlign = 'top';
}

return (_ctx: any,_cache: any) => {
  return (__props.span)
    ? (_openBlock(), _createElementBlock("span", _mergeProps({ key: 0 }, _ctx.$attrs, {
        class: _ctx.$style.container,
        style: _unref(style).container
      }), [
        (truncate.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(truncateStyle.value)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4))
          : _renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 16))
    : (_openBlock(), _createElementBlock("div", _mergeProps({ key: 1 }, _ctx.$attrs, {
        class: _ctx.$style.container,
        style: _unref(style).container
      }), [
        (truncate.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(truncateStyle.value)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4))
          : _renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 16))
}
}

})